import { render, staticRenderFns } from "./Zz.vue?vue&type=template&id=04662e16&scoped=true&"
import script from "./Zz.vue?vue&type=script&lang=js&"
export * from "./Zz.vue?vue&type=script&lang=js&"
import style0 from "./Zz.vue?vue&type=style&index=0&id=04662e16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04662e16",
  null
  
)

export default component.exports